export default "__VITE_ASSET___yH4$usx__"